import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { clearCart } from "../../redux/slices/cart";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useQueryClient } from "@tanstack/react-query";
import PaymentForm from "../PaymentForm/PaymentForm";
import "./PaymentStep.css";

const stripePromise = loadStripe("pk_test_YOUR_KEY_HERE");

const PaymentStep = ({ orderData, onBack }) => {
  const [clientSecret, setClientSecret] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isFreeOrder, setIsFreeOrder] = useState(false);
  const [isSyncing, setIsSyncing] = useState(false);
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  useEffect(() => {
    const total = parseFloat(orderData?.discountedTotal || 0);
    if (total === 0) {
      setIsFreeOrder(true);
      setLoading(false);
      return;
    }

    if (orderData?.stripe_payment_intent_client_secret) {
      setClientSecret(orderData.stripe_payment_intent_client_secret);
      setLoading(false);
    } else {
      setError("Payment details missing. Please go back.");
      setLoading(false);
    }
  }, [orderData]);

  // 🔥 NEW: Automatic Background Invalidation
  // This triggers as soon as the success UI renders, so even if they
  // refresh or close the tab, the "old" data is marked as trash.
  useEffect(() => {
    if (isFreeOrder) {
      queryClient.removeQueries({ queryKey: ["userLibrary"] });
      queryClient.removeQueries({ queryKey: ["product"] });
      // We don't redirect here, just prep the cache
    }
  }, [isFreeOrder, queryClient]);

  if (loading) return <div className="PaymentStep">Loading...</div>;

  if (isFreeOrder) {
    return (
      <section className="PaymentStep">
        <div style={{ textAlign: "center", padding: "40px 20px" }}>
          <h2 style={{ color: "#4caf50" }}>🎉 Order Successful!</h2>
          <p>Free order #{orderData.orderId} processed.</p>
          <button
            disabled={isSyncing}
            onClick={() => {
              setIsSyncing(true);

              // 1. HARD WIPE of local cache memory
              queryClient.removeQueries({ queryKey: ["userLibrary"] });
              queryClient.removeQueries({ queryKey: ["product"] });

              // 2. WAIT for the server to finish writing to WooCommerce DB
              setTimeout(() => {
                queryClient.invalidateQueries({ queryKey: ["userLibrary"] });
                queryClient.invalidateQueries({ queryKey: ["product"] });

                dispatch(clearCart());
                window.location.href = "/";
              }, 5000);
            }}
            style={{
              marginTop: "20px",
              backgroundColor: isSyncing ? "#ccc" : "#007cba",
              color: "white",
              padding: "12px 24px",
              border: "none",
              borderRadius: "4px",
              cursor: isSyncing ? "not-allowed" : "pointer",
            }}
          >
            {isSyncing ? "Finalizing Library..." : "Continue Shopping"}
          </button>
        </div>
      </section>
    );
  }

  return (
    <Elements stripe={stripePromise}>
      <PaymentForm
        orderData={orderData}
        onBack={onBack}
        clientSecret={clientSecret}
      />
    </Elements>
  );
};

export default PaymentStep;
